module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "login-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "fa": "user",
      "mdi": "person_outline",
      "placeholder": "Email",
      "value": _vm.credentials.email,
      "error": _vm.errors.email,
      "required": "true",
      "autofocus": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "fa": "lock",
      "mdi": "lock_outline",
      "placeholder": "Password",
      "value": _vm.credentials.password,
      "error": _vm.errors.password,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("\n                        Remember Me\n                  ")])]), _vm._v(" "), _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                  Login\n                ")])])], 1)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "{ route('password.request') }"
    }
  }, [_vm._v("Forgot password")]), _vm._v("\n               \n            "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Need help?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e632f92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_auth/Login.vue
// module id = 800
// module chunks = 1